import { TagCard } from "./TagCard";
import { MappedTag } from "@/utils/tagMapping";

interface TagGridProps {
  tags: MappedTag[];
  onDelete: (id: string) => void;
}

export const TagGrid = ({ tags, onDelete }: TagGridProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {tags.map((tag) => (
        <TagCard
          key={tag.id}
          tag={tag}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};